import React from "react";

const Content = ({ children }) => {
    return <div className="info-blocks">{children}</div>;
};

export default Content;